module.exports = __webpack_public_path__ + "img/p2_top.bb1bdc33.png";